export default __webpack_public_path__ + "img/clock.af0aed52.svg";